import { Expose, Transform } from 'class-transformer';
import { IsString, IsInt, IsNumber } from 'class-validator';

export default class ClusterHotelsModel {
    @Expose()
    @Transform((_, plain) => plain.hotel_name)
    @IsString()
    hotelName!: string;

    @Expose()
    @Transform((_, plain) => plain.fornovaId || plain.fornova_id)
    @IsInt()
    hotelId!: number;

    @Expose()
    @IsNumber()
    @Transform((_, plain) => Math.round(Number(plain.total_score)))
    totalScore!: number;

    @Expose()
    @IsNumber()
    @Transform((_, plain) => Math.round(Number(plain.rate_score)))
    ratesScore!: number;

    @Expose()
    @IsNumber()
    @Transform((_, plain) => plain.diff_score)
    newTotalScore!: number;

    documentLoaded: boolean = false;
}
